var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimRowResubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 4h12c.5522847 0 1 .44771525 1 1v14c0 .5522847-.4477153 1-1 1h-12c-.55228475 0-1-.4477153-1-1v-14c0-.55228475.44771525-1 1-1zm1 3v1h5v-1zm0 5v1h10v-1zm0 2v1h9v-1zm0 2v1h5v-1z",
    fill: "#dee2e6",
    transform: "translate(-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 7,
    fill: "#dee2e6",
    r: 8,
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.916667,
    transform: "translate(13 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.66666667.33333333 1.33333333 1.33333334-1.33333333 1.33333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 3.66666667v-.66666667c0-.73637967.59695367-1.33333333 1.33333333-1.33333333h4.66666667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.33333333 7.66666667-1.33333333-1.33333334 1.33333333-1.33333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 4.33333333v.66666667c0 .73637967-.59695367 1.33333333-1.33333333 1.33333333h-4.66666667"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimRowResubmitted);
export default __webpack_public_path__ + "static/media/claim-row-resubmitted.dd8167abc77e629724af7805111b662a.svg";
export { ForwardRef as ReactComponent };